import * as React from 'react';
import * as styles from './styles.css';

import { ModalFullscreen, Button } from '@cian/ui-kit';

export interface ISearchTextModalProps {
  isOpen: boolean;
  onClose(): void;
  searchTextFilter: React.ReactNode;
  content?: React.ReactNode;
}

export function SearchTextModal({ isOpen, onClose, searchTextFilter, content }: ISearchTextModalProps) {
  return (
    <ModalFullscreen open={isOpen} onClose={onClose}>
      <div className={styles['container']}>
        <div className={styles['search-row']}>
          <div className={styles['input']}>{searchTextFilter}</div>
          <Button theme="fill_white_primary" size="M" onClick={onClose}>
            Отмена
          </Button>
        </div>
        {content}
      </div>
    </ModalFullscreen>
  );
}
